export default class Page {
	constructor(r) {
		this.item = {};
		if(r != false) {
			this.item = r;
		}

		this.defaults();
	}

	isset(key) {
		if(typeof this.item[key] === 'undefined') {
			return false;
		}

		return true;
	}

	output() {
		return this.item;
	}

	defaults() {
		if(!this.isset('backgroundColor')) {
			this.item.backgroundColor = '#ecf3f5';
		}

		if(!this.isset('padding')) {
			this.item.padding = '0px 0px 0px 0px';
		}

		if(!this.isset('font')) {
			this.item.type = 'inherit';
		}

		if(!this.isset('fontSize')) {
			this.item.fontSize = 'inherit';
		}

		if(!this.isset('color')) {
			this.item.color = 'inherit';
		}

		if(!this.isset('type')) {
			this.item.type = '';
		}

		if(!this.isset('subject')) {
			this.item.subject = '';
		}

		if(!this.isset('borderTop')) {
			this.item.borderTop = 'none';
		}
		
		if(!this.isset('borderBottom')) {
			this.item.borderBottom = 'none';
		}
	}
}


// WEBPACK FOOTER //
// ./helpers/page.js